import { GenericFilterModel } from "traveldesk-ui";

export default class HotelsFilter extends GenericFilterModel {
    countryId: number = 0
}